// Accessible expand/collapse helper.
export const isExpanded = (el) => {
  // Early return in case element is undefined.
  if (!el) {
    return false;
  }

  // Fallback to computed styles if no values have been set by JS yet.
  return (
    (el.style.height ||
      window.getComputedStyle(el).getPropertyValue('height')) !== '0px'
  );
};

export const expand = (el, trigger) => {
  el.style.height = `${el.scrollHeight}px`;
  el.style.opacity = '1';
  el.setAttribute('aria-hidden', false);

  if (trigger) {
    trigger.setAttribute('aria-expanded', true);
  }
};

export const collapse = (el, trigger) => {
  el.style.height = '0';
  el.style.opacity = '0';
  el.setAttribute('aria-hidden', true);

  if (trigger) {
    trigger.setAttribute('aria-expanded', false);
  }
};

export const expandCollapse = (el, trigger = null, siblings = null) => {
  if (isExpanded(el)) {
    collapse(el, trigger);
  } else {
    // Collapse any expanded sibling elements.
    if (siblings) {
      siblings.forEach((item) => {
        collapse(item);
      });
    }
    // Expand target element.
    expand(el, trigger);
  }
};
